









import { Component, Vue } from 'vue-property-decorator';
import { CertificateInfo } from '@luxtag/papybase';
import ProductListContainer from '@/components/product/product-list/ProductListContainer.vue';
import { filter } from 'lodash';

@Component({
    components: {
        ProductListContainer,
    },
})
export default class TransferredProducts extends Vue {
    get products(): CertificateInfo[] {
        const products: CertificateInfo[] = this.$store.getters.getProducts;
        return filter(products, (product) => {
            const isUnclaimed: boolean = this.$store.getters.isTransferred(product.address);
            return isUnclaimed;
        });
    }
}
